import { PGSettlements } from "./../../../../../Integrations"
import { useOutletContext } from "react-router"

export default function PGIntegrationItemSettlementsPage() {
	const context = useOutletContext<{ appId: number }>()
	return <PGSettlements appId={context.appId} />
}
